import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

/**
 * 首页
 */
export function mallShopCate(data){//获取店铺分类
	return request.get(config.baseApi+"/business/Mall/shopCate",data)
}
export function mallCateData(data){//获取首页分类
	return request.get(config.baseApi+"/business/Mall/cateData",data)
}
export function mallProductList(data){//获取首页商品列表
	return request.get(config.baseApi+"/business/Mall/productList",data)
}
export function searchProductByImage(data){//图片搜索商品
	return request.post(config.baseApi+"/business/Mall/searchProductByImage",data)
}
export function searchAlibabaProductByImage(data){//图片搜索阿里巴巴商品
	return request.post(config.baseApi+"/business/Mall/searchAlibabaProductByImage",data)
}
export function getAlibabaProductFilterTypeList(data){//获取1688精选货源商品筛选类型列表
	return request.get(config.baseApi+"/business/Mall/getAlibabaProductFilterTypeList",data)
}

export function businessOrderCount(data){//获取商家订单数量
	return request.get(config.baseApi+"/business/Mall/businessOrderCount",data)
}
export function productSelect(data){//商品选取
	return request.post(config.baseApi+"/business/Cart/add",data)
}
export function indexBannerData(data){//首页banner，广告
	return request.get(config.baseApi+"/business/Advert/index",data)
}
export function announcementData(data){//获取公告列表
	return request.get(config.baseApi+"/business/Announcement/list",data)
}
export function announcementDetail(data){//获取公告详情
	return request.get(config.baseApi+"/business/Announcement/detail",data)
}
export function singlePageData(data){//获取单页列表
	return request.get(config.baseApi+"/business/Page/list",data)
}
export function singlePageDetail(data){//获取单页详情
	return request.get(config.baseApi+"/business/Page/detail",data)
}


/**
 * 商品详情
 */
export function productDetail(data){//获取商品详情
	return request.get(config.baseApi+"/business/Mall/productDetail",data)
}



